import { withNamespaces } from "react-i18next";
import { Label, UncontrolledTooltip } from "reactstrap";
import AIIcon from "src/assets/images/sparkling.png";

const AIFieldLabel = ({ t, id, label, aiGenerated, tooltipText, children }) => {
    const tooltipId = `ai-tooltip-${id}`;

    return (
        <div className="d-flex align-items-start">
            <Label className="form-label" for={id}>
                {label}
            </Label>

            {aiGenerated && (
                <>
                    <span
                        id={tooltipId}
                        className="ms-2 text-warning d-inline-flex align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <img style={{
                            width: '22px'
                        }} src={AIIcon} alt="" />
                    </span>

                    <UncontrolledTooltip
                        placement="top"
                        target={tooltipId}
                    >
                        {tooltipText || t("This field contains AI-generated content and may require verification.")}
                    </UncontrolledTooltip>
                </>
            )}

            {children}
        </div>
    );
};

export default withNamespaces()(
    AIFieldLabel
);